import type { DriverWorkContext } from '../api/apiService';
import type { TFunction } from 'i18next';

/** Shared presentation of the server's effective payer and actual interval. */
export function workContextLicenseLabel(context: DriverWorkContext, t: TFunction<'workCompany'>) {
  const personalLabel = context.license.interval === 'month'
    ? t('personalMonth', 'Personal - Monthly')
    : context.license.interval === 'year'
      ? t('personalYear', 'Personal - Annual') : t('personal', 'Personal');
  return context.license.payer === 'company' ? t('companyLicense', 'Company-funded')
    : context.license.payer === 'self' ? personalLabel : t('unknownLicense', 'To confirm');
}
